import React, { useState } from 'react';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';

import InputLabel from './InputLabel';
import { DatePickerProps } from './Types';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

const RangeDatePickerInput: React.FC<DatePickerProps> = ({
  placeholder = 'Start date, End date',
  name,
  value = null,
  showTime = false,
  onChange,
  shape = 'squre',
  color = 'textPrimary',
  bg = 'white',
  label,
  required = false,
  allowClear = true,
}) => {
  const datesProp = value?.split(', ');
  const placeholders = placeholder?.split(', ');

  const [startDate, setStartDate] = useState(
    datesProp ? dayjs(datesProp[0]) : null
  );
  const [endDate, setEndDate] = useState(
    datesProp ? dayjs(datesProp[1]) : null
  );

  const onSelect = (values: any, formatString: [string, string]) => {
    if (values) {
      setStartDate(values[0]);
      setEndDate(values[1]);
      onChange(
        name,
        `${dayjs(values[0]).toISOString()}, ${dayjs(values[1]).toISOString()}`
      );
    } else {
      onChange(name, '');
    }
  };

  const { t } = useTranslation();

  return (
    <div>
      {label && <InputLabel text={label} name={name} required={required} />}

      <RangePicker
        className={`input focus:ring-primary p-2 px-2 align-middle  focus:ring-4 cursor-pointer  focus:ring-opacity-10 focus:ring-offset-0  ${
          shape === 'circle' ? 'rounded-full' : 'rounded-md'
        } bg-${bg} text-${color} focus:border-primary  w-full   sm:text-sm border-gray-300 `}
        placeholder={[
          t(`inputs.placeholders.${placeholders[0]}`, placeholders[0] || ''),
          t(`inputs.placeholders.${placeholders[1]}`, placeholders[1] || ''),
        ]}
        showTime={showTime}
        name={name}
        onChange={onSelect}
        defaultValue={[startDate, endDate]}
        allowClear={allowClear}
      />
    </div>
  );
};

export default RangeDatePickerInput;
